// El archivo se descarga con fetch porque el wrapper de api solo maneja JSON
export const descargarReporteExcel = async (endpoint, params, nombreArchivo) => {
    const query = new URLSearchParams(params).toString();

    const response = await fetch(`/api/${endpoint}?${query}`, {
        method: "GET",
        headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
        },
    });

    if (!response.ok) {
        let errorData;

        try {
            errorData = await response.json();
        } catch (error) {
            errorData = { detail: `Error HTTP ${response.status}` };
        }

        throw errorData;
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const enlace = document.createElement("a");
    enlace.href = url;
    enlace.download = nombreArchivo;
    enlace.click();

    window.URL.revokeObjectURL(url);
};
